export default {
  refundRecord_00001: "Registro de reembolso",
  refundRecord_00002: "Fecha de reembolso",
  refundRecord_00003: "Monto del reembolso ({0})",
  refundRecord_00004: 'El sistema realizó un reembolso automático (pago por WeChat)',
  refundRecord_00005: 'Reembolso automático del sistema (Alipay)',
  refundRecord_00006: '{name} un reembolso manual',
  }